import{ useState, useEffect, useRef } from "react";
import '../../assets/css/EditProfile.css';
import { IoPencilSharp } from "react-icons/io5";
import CustomButton from "../../components/CustomButton";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { saveProfileData } from "../../redux/UserDataSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import dummygallaryImage from '../../assets/images/dummy-banner.jpg';
import { IoIosArrowDropleft } from "react-icons/io";


const EditProfile = ({ onSetMenuItem }) => {
    const [formData, setFormData] = useState({
        avatarName: "",
        avatarUrl: '',
        name: "",
        notes: "",
        age: "",
        gender: "Male",
        location: "",
        subLocation: "",
        address: "",
        zipCode: "",
        email: "",
        phone: "",
        favoriteCourt: "",
        preferableTime: "",
        gallery: [],
    });
    const { userId, courtData } = useSelector((state) => state.loginInfo);
    const dispatch = useDispatch();

    const { accessToken, profileData } = useSelector((state) => state.loginInfo);
    const [loading, setLoading] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const image = location?.state?.image;
    const [gallery, setGallery] = useState(["", "", "", "", "", ""]);
    const fileInputRefs = useRef([]);

    const US_STATES = [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Louisiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virginia", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" }
    ];

    useEffect(() => {
        if (profileData?.baseProfile) {
            const profile = profileData.baseProfile;
            setFormData({
                avatarName: profile?.avatarName || "",
                avatarUrl: profile?.avatarUrl,
                name: profile.name || "",
                notes: profile.note || "",
                age: profile.age || "",
                gender: profile.gender === "MALE" ? "Male" : profile.gender === "FEMALE" ? "Female" : "Other",
                location: profile?.city || "",
                address: profile?.street || "",
                zipCode: profile?.zipcode || "",
                email: profile?.email || "",
                phone: profile?.mobileNumber || "",
                favoriteCourt: profile?.preferrableCourt?.toString() || "",
                preferableTime: profile?.preferredTime || "",
                gallery: profile?.images?.image || [],
                latitude: profile?.latitude,
                longitude: profile?.longitude,
                stringer: profile?.stringer,
                state: profile?.state
            });
            const realImages = profileData?.baseProfile?.images?.image;
            const paddedGallery = [...realImages];
            while (paddedGallery.length < 5) {
                paddedGallery.push("");
            }
            setGallery(paddedGallery);
        }
    }, [profileData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const fetchProfileData = async () => {
        try {

            const result = await apiHandler({
                url: `${endpoint.PLAYER_PROFILE}?id=${userId}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });
            dispatch(saveProfileData(result?.data));
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
        setTimeout(() => setLoading(false), 3000);
    }

    const onEditSubmit = async () => {
        if (!validateForm()) return;
        const data = {
            name: formData?.name,
            gender: formData?.gender?.toUpperCase(),
            avatarUrl: image ? image : profileData?.baseProfile?.avatarUrl,
            avatarName: formData?.avatarName,
            note: formData?.notes,
            longitude: formData?.longitude,
            latitude: formData?.latitude,
            street: formData?.address,
            city: formData?.location,
            state: "LA",
            country: "CA",
            zipcode: formData.zipCode,
            stringer: false,
            images: { image: formData.gallery },
            preferredTime: formData.preferableTime,
            preferrableCourt: 1, // consider renaming to preferredCourt
        };
        setLoading(true);
        try {
            const result = await apiHandler({
                url: endpoint.EDIT_PROFILE,
                method: 'POST',
                data,
                authToken: accessToken?.accessToken,
            });
            if (result.data && !result?.data?.error_description) {
                toast.success("Updated Successfully");
                navigate('/profile');
                onSetMenuItem('player-profile');
                fetchProfileData();
            } else {
                toast.error(result?.data?.user_description);
            }
        } catch (error) {
            console.error(error);
            // toast.error("Something went wrong. Try again.");
        }
        setTimeout(() => setLoading(false), 7000);
    };

    const validateForm = () => {
        const { name, email, phone, location, address, zipCode, state } = formData;
        if (!name.trim()) {
            toast.error("Name is required.");
            return false;
        }

        if (!phone.trim()) {
            toast.error("Phone number is required.");
            return false;
        }

        if (!location.trim()) {
            toast.error("City is required.");
            return false;
        }

        if (!address.trim()) {
            toast.error("Street address is required.");
            return false;
        }

        if (!zipCode.trim()) {
            toast.error("Zip code is required.");
            return false;
        }

        if (!/^\d{5}$/.test(zipCode)) {
            toast.error("Zip code must be 5 digits.");
            return false;
        }

        if (!state?.trim()) {
            toast.error("State is required.");
            return false;
        }

        return true;
    };

    const handleImageChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const imageURL = URL.createObjectURL(file);
            const newGallery = [...gallery];
            newGallery[index] = imageURL;
            setGallery(newGallery);
            setFormData((prevFormData) => {
                const updatedGallery = [...prevFormData.gallery];
                updatedGallery[index] = imageURL;
                return { ...prevFormData, gallery: updatedGallery };
            });
        }
    };

    const handleRemoveImage = (index) => {
        const newGallery = [...gallery];
        newGallery[index] = "";
        setGallery(newGallery);
    };

    const triggerFileInput = (index) => {
        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].click();
        }
    };
    const onGoToBackPage = () => {
        navigate(-1)
    }

    const onEditAvtar = () => {
        navigate('/choose-avatar')
    }

    return (
        <div className="container my-3" style={{ borderRadius: '10px' }}>
            <div className="edit-profile-container">
                <div className="row justify-content-center" style={{ margin: '0px', border: '10px' }}>
                    <div className="edit-profile-wrapper p-0 p-sm-4">
                        <div className="d-flex justify-content-between edit-back-txt-wrapper" >
                            <CustomButton
                                className="back-page-btn"
                                onClick={onGoToBackPage}
                                buttonText={
                                    <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
                                }
                            />
                            <h3 className="text-center mb-4 edit-profile-txt fs-3">Edit Profile</h3>
                        </div>
                        <form className="mx-auto">
                            <div className="text-center mb-3">
                                <div className="position-relative d-inline-block">
                                    <img
                                        src={image ? image : profileData?.baseProfile?.avatarUrl}
                                        alt="Avatar"
                                        className="rounded-circle"
                                        style={{ width: "100px", height: "100px", border: '2px solid' }}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm position-absolute"
                                        style={{
                                            bottom: '0px',
                                            right: '0px',
                                            width: '40px',
                                            height: '40px', display: 'flex',
                                            alignItems: 'center',
                                            borderRadius: '36px'
                                        }}
                                        onClick={onEditAvtar}
                                    >
                                        <IoPencilSharp style={{ position: 'absolute', top: '12px', left: '11px' }} />
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                {[
                                    { label: "Avatar Name", name: "avatarName", disabled: true },
                                    { label: "Name", name: "name", disabled: true },
                                    { label: "Notes", name: "notes" },
                                    { label: "Age", name: "age", type: "number", disabled: true },
                                ].map((field, index) => (
                                    <div className="col-md-4 mb-3" key={index}>
                                        <label htmlFor={field.name} className="form-label">{field.label}</label>
                                        <input
                                            type={field.type || "text"}
                                            className="form-control"
                                            id={field.name}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            disabled={field.disabled}
                                        />
                                    </div>
                                ))}

                                <div className="col-md-4 mb-3">
                                    <label htmlFor="gender" className="form-label">Gender</label>
                                    <select
                                        className="form-select"
                                        id="gender"
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                    >
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                {[
                                    { label: "Street Address", name: "address" },
                                    { label: "City", name: "location" },

                                    { label: "Zip Code", name: "zipCode" },
                                    { label: "Email", name: "email", type: "email", disabled: true },
                                    { label: "Phone", name: "phone" },
                                    { label: "Preferable Time", name: "preferableTime", type: "time" }
                                ].map((field, index) => (
                                    <div className="col-md-4 mb-3" key={index}>
                                        <label htmlFor={field.name} className="form-label">{field.label}</label>
                                        <input
                                            type={field.type || "text"}
                                            className="form-control"
                                            id={field.name}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            disabled={field.disabled}
                                        />
                                    </div>
                                ))}

                                <div className="col-md-4 mb-3">
                                    <label htmlFor="state" className="form-label">Favorite Court</label>
                                    <select
                                        name="favoriteCourt"
                                        className="form-control"
                                        value={formData.favoriteCourt}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select State</option>
                                        {courtData.map((state) => (
                                            <option key={state.courtName} value={state.courtName}>
                                                {state.courtName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label htmlFor="state" className="form-label">State</label>
                                    <select
                                        name="state"
                                        className="form-control"
                                        value={formData.state}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select State</option>
                                        {US_STATES.map((state) => (
                                            <option key={state.abbreviation} value={state.abbreviation}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-8 mb-3">
                                    <label className="form-label">Upload Images</label>
                                    <div className="d-flex flex-wrap gap-4">
                                        {gallery.map((img, index) => (
                                            <div
                                                key={index}
                                                className="position-relative"
                                                style={{
                                                    width: "75px",
                                                    height: "75px",
                                                    border: "1px solid #ccc",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    position: "relative",
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                }}
                                            >
                                                {img ? (
                                                    <>
                                                        <img className="w-100 h-100"
                                                            src={`${gallery.length > 0 ? `${endpoint.BASE_URL_STAGING}/public/images/${img}` : dummygallaryImage}`}
                                                            alt="Gallery"
                                                            style={{ objectFit: "cover" }}
                                                        />
                                                        <button
                                                            type="button"
                                                            style={{
                                                                position: 'absolute',
                                                                width: '25px',
                                                                height: '25px',
                                                                bottom: '0px',
                                                                right: '-13px',
                                                                borderRadius: '25px',
                                                                background: '#006FFD',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: 0,
                                                            }}
                                                            onClick={() => handleRemoveImage(index)}
                                                        >
                                                            <ImCross style={{ color: 'white', fontSize: '12px' }} />
                                                        </button>

                                                    </>
                                                ) : (
                                                    <>
                                                        <button
                                                            type="button"
                                                            style={{
                                                                position: 'absolute',
                                                                width: '25px',
                                                                height: '25px',
                                                                bottom: '0px',
                                                                right: '-13px',
                                                                borderRadius: '25px',
                                                                background: '#006FFD',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: 0,
                                                            }}
                                                            onClick={() => triggerFileInput(index)}
                                                        >
                                                            <FaPlus style={{ color: 'white' }} />
                                                        </button>

                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            ref={(el) => (fileInputRefs.current[index] = el)}
                                                            onChange={(e) => handleImageChange(e, index)}
                                                            style={{ display: "none" }}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 text-center">
                                <CustomButton
                                    buttonText={'Save Changes'}
                                    style={{
                                        width: '450px',
                                        height: '48px',
                                        borderRadius: '12px',
                                        background: '#006FFD',
                                        color: '#FFFFFF',
                                        border: 'none'
                                    }}
                                    onClick={onEditSubmit}
                                    disabled={loading}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditProfile;
